export default {
  TITLE_LOGIN: 'PACMNY - Login',
  TITLE_REGISTER: 'PACMNY - Register',
  TITLE_WELCOME: 'PACMNY - Welcome',
  TITLE_PROVIDER: 'PACMNY - Provider',
  TITLE_PROVIDERS: 'PACMNY - Providers',
  TITLE_PROCEDURES: 'PACMNY - Procedures',
  TITLE_DIAGNOSIS: 'PACMNY - Diagnosis',
  TITLE_MEDICATION: 'PACMNY - Medication',
  TITLE_VACCINATION: 'PACMNY - Vaccination',
  TITLE_CDA: 'PACMNY - CDAs',
  TITLE_REPORT: 'PACMNY - Report',
  TITLE_REPORTS: 'PACMNY - Reports',
  TITLE_PDF: 'PACMNY - PDFs',
  TITLE_WATCH: 'PACMNY - Graph your health condition',
  TITLE_VITALS: 'PACMNY - Graph your vitals',
  TITLE_PROFILE: 'PACMNY - Profile',
  TITLE_CONTACT: 'PACMNY - Contact',
  TITLE_404: 'Page Not Found',
  TITLE_SEARCH: 'Search',
  TITLE_ALLERGY: 'PACMNY - Allergy',
  TITLE_FORGOT: 'Forgot Password',
  TITLE_RESET: 'Reset Password',
  TITLE_VERIFY: 'Verify Your Account',
  TITLE_DIRECTIVES: 'PACMNY - Directives',
  TITLE_DEVICES: 'PACMNY - Devices',
  TITLE_NOTES: 'PACMNY - Notes',
  DATA_UPLOAD: 'Data Upload',
  TITLE_CURRENT_PROC: 'PACMNY - Current Procedures',
  TITLE_CURRENT_DIAG: 'PACMNY - Current Diagnosis',
  TITLE_CURRENT_MED: 'PACMNY - Current Medications',
  TITLE_CURRENT_PROV: 'PACMNY - Current Providers',
  TITLE_CURRENT_NURSE: 'PACMNY - Account Nurses',
  TITLE_PATIENT_NURSE: 'EMR - Patient Nurses',
  TITLE_MY_ACCOUNT:'PACMNY - My Account',
  TITLE_ORDERS: 'PACMNY - Orders',
  TITLE_MED_ADMIN: 'PACMNY - Medication Administration',
  TITLE_CPT_BILLING: 'PACMNY - CPT Billing',
  TITLE_CPT_PAGE: 'PACMNY - CPT Codes',
  TITLE_VERIFY_NURSE: 'PACMNY - Verify Nurse'
}
